module.exports = __webpack_public_path__ + "static/media/ma.ab22799e.png";